'use strict';

customerZone.controller('InvoiceHistoryController', ['$log', '$location', '$timeout', 'Session', 'utils',
    'UnleashedClient', function($log, $location, $timeout, session, utils, api){

        var self = this;
        self.history = [];
        self.paymentMode = false;

        self.token = session.token;

        self.loadInvoices = function(page){
            return api.getInvoiceHistory(page)
                .then(function (invoices) {
                    if (self.paymentMode)
                        return invoices.filter(function(invoice){ return !invoice.paid; });
                    else
                        return invoices;
                }, function (error) {
                    $log.error('failed to load invoice history: ', error);
                    return [];
                });
        };

        self.pageTitle = function(){
            if (self.paymentMode)
                return 'title_pay_an_invoice';
            else
                return 'title_invoice_overview';
        };

        self.pay = function(invoice){
            $log.debug('Paying invoice '+invoice);
            var paymentPromise = api.payInvoice(invoice.id, utils.cleanUrlAsMollieRedirect(utils.currentPath()))
                .then(function(response){
                    utils.redirect(response.paymentUrl);
                    busy.freeze();
                });
            var busy = utils.showBusy(paymentPromise, 'loading_payment_page', 'conform_invoice_paid');
            return paymentPromise;
        };

        var init = function(){
            self.paymentMode = !!/\/pay$/.exec($location.path());
            if (self.paymentMode && $location.search().ref)
                $timeout(function(){
                    // we need to skip the thread to allow the payment selection
                    // to be set.
                    self.pay({id: $location.search().ref});
                }, 250);
        };

        init();
    }]);
